import { render } from "./vital-sign-button-js.vue?vue&type=template&id=59e356b8&scoped=true"
import script from "./vital-sign-button-js.vue?vue&type=script&lang=js"
export * from "./vital-sign-button-js.vue?vue&type=script&lang=js"

import "./vital-sign-button-js.vue?vue&type=style&index=0&id=59e356b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e356b8"]])

export default __exports__